import { useNavigate } from 'react-router-dom';

import { Page, Button, EditIcon } from '@occc-app/design-system';
import { RetailerNetworkFragment } from '@occc/graphql';
import { Can } from '@occc-app/App/PolicyBasedAccessControl';
import { UpdateRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';

import { RetailerNetworkLocationsAndGroups } from './components/retailer-network-locations-and-groups/retailer-network-locations-and-groups.component';
import { RetailerNetworkDetailsSection } from './components/retailer-network-details-section.component';

import RetailerNetworkMonthlyGoals from '../components/retailer-network-monthly-goals/retailer-network-monthly-goals.container';
import RetailerNetworkPerformance from '../components/retailer-network-performance';
import RetailerNetworkUsersConfigurationSection from '../retailer-network-users-configuration';
import { routeCreator } from '../retailer-connect.utils';
import { RetailerNetworkUpdateHandler } from '../retailer-connect.types';

const PAGE_TITLE = 'Retailer Network Details';

type RetailerNetworkDetailsPageProps = {
  retailerNetwork: RetailerNetworkFragment;
  retailerNetworkUpdate: RetailerNetworkUpdateHandler;
};

export const RetailerNetworkDetailsPage = ({
  retailerNetwork,
  retailerNetworkUpdate,
}: RetailerNetworkDetailsPageProps) => {
  const navigate = useNavigate();
  const hasLocationsOrLocationGroups =
    !!retailerNetwork.numberOfLocations || !!retailerNetwork.numberOfLocationGroups;

  const onEditClick = () =>
    navigate(routeCreator.configurationUpdateNetworkDetails(retailerNetwork.uuid));

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{ title: retailerNetwork.name }}
      containerProps={{ variant: 'md' }}
      actions={
        <Can I={UpdateRetailerNetwork(retailerNetwork)}>
          <Button
            variant='contained'
            color='secondary'
            startIcon={<EditIcon />}
            onClick={onEditClick}
          >
            Edit
          </Button>
        </Can>
      }
    >
      <RetailerNetworkMonthlyGoals
        filter={{
          retailerNetworkUuidEquals: retailerNetwork.uuid,
        }}
      />

      <RetailerNetworkDetailsSection retailerNetwork={retailerNetwork} />
      {hasLocationsOrLocationGroups && (
        <>
          <RetailerNetworkPerformance
            filter={{ retailerNetworkUuidEquals: retailerNetwork.uuid }}
            scope='network'
            retailerNetworkGoals={{
              membersPerStore: retailerNetwork.monthlyPerformanceGoal.membersPerStore,
              transactionsPerStore: retailerNetwork.monthlyPerformanceGoal.transactionsPerStore,
            }}
          />
          <RetailerNetworkLocationsAndGroups
            retailerNetworkUuid={retailerNetwork.uuid}
            retailerNetworkUpdate={retailerNetworkUpdate}
            customerId={retailerNetwork.customerId}
          />
        </>
      )}
      <RetailerNetworkUsersConfigurationSection
        retailerNetwork={retailerNetwork}
        retailerNetworkUpdate={retailerNetworkUpdate}
      />
    </Page>
  );
};
